import React from 'react'
import { Grid, Button } from 'semantic-ui-react';
import { dispatch } from '@rematch/core';
import { Form } from 'formsy-semantic-ui-react';
import { toastr } from 'react-redux-toastr';

import { source } from 'react-aim';
import EllipsisTooltip from '../../../../common/EllipsisTooltip';
let optionsArray = [];
let propName = '';
let propValue = '';

@source({
    mouseEnter: (props, component) => {
        dispatch.app.setHelpContext('Assigned Activities Card')
    }
})

class CommunityActivityResourcePaneForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            option: 'raci',
            isDisabled: true
        }
        this.deleteR = this.deleteR.bind(this);
        this.deleteA = this.deleteA.bind(this);
        this.deleteC = this.deleteC.bind(this);
        this.deleteI = this.deleteI.bind(this);
        this.createRaciObject = this.createRaciObject.bind(this);
    }
    componentWillMount() {
        this.createOptionsArray();
    }
    componentWillReceiveProps() {
        this.setState({ option: 'raci' });
        optionsArray = [];
    }
    createOptionsArray() {
        optionsArray = [];
        if (this.props.activityOptions) {
            this.props.activityOptions.map((activity) => {
                if (!this.props.selectedPracticeFlowCommunity.raci ||
                    ((propName === 'r' || propName === 'a' || propName === 'c' || propName === 'i') &&
                        (!this.props.selectedPracticeFlowCommunity.raci[propName] || this.props.selectedPracticeFlowCommunity.raci[propName].indexOf(activity._id) == -1))
                ) {
                    optionsArray.push({ id: activity._id, label: activity.name });
                }

                if (activity.activities) {
                    activity.activities.map((subActivity) => {
                        if (subActivity.isParentNode) {
                            if (!this.props.selectedPracticeFlowCommunity.raci ||
                                ((propName === 'r' || propName === 'a' || propName === 'c' || propName === 'i') &&
                                    (!this.props.selectedPracticeFlowCommunity.raci[propName] || this.props.selectedPracticeFlowCommunity.raci[propName].indexOf(subActivity._id) == -1))
                            ) {
                                optionsArray.push({ id: subActivity._id, label: activity.name + " > " + subActivity.name });
                            }
                        }

                    })
                }

            });
        }
    }
    resetDropDown() {
        this.setState({ option: 'raci' })
    }
    createRaciObject(data) {
        switch (data.target.name) {
            case 'raci': propName = data.target.value ? data.target.value : '';
                this.setState({ option: data.target.value });
                this.createOptionsArray();
                break;
            case 'assignment': propValue = data.target.value ? data.target.value : '';
        }
        if (propName && propValue) {
            this.setState({ isDisabled: false })
        }
    }
    addRaciToCommunity(formData, resetForm) {
        if ((propName === 'r' || propName === 'a' || propName === 'c' || propName === 'i') && (propValue && propValue != 'Select')) {
            if (!this.props.selectedPracticeFlowCommunity.raci) {
                this.props.selectedPracticeFlowCommunity.raci = {};
            }
            if (!this.props.selectedPracticeFlowCommunity.raci[propName])
                this.props.selectedPracticeFlowCommunity.raci[propName] = [];
            this.props.selectedPracticeFlowCommunity.raci[propName].push(propValue);
            dispatch.createPack.setRACIObjectOnCommunity(this.props.selectedPracticeFlowCommunity.raci);
            let actionObject = {};
            actionObject[propName] = propValue;
            dispatch.createPack.updateCommunityAction(actionObject);
            this.props.editCommunity();
            propName = '';
            propValue = '';
            this.setState({ isDisabled: true });
        }
        else {
            toastr.error('Message', 'Please select options from dropdown.');
        }
        this.resetDropDown();

    }
    getMapping(id) {
        if (this.props.activityOptions)
            for (let i = 0; i < this.props.activityOptions.length; i++) {
                let activity = this.props.activityOptions[i];
                if (id == activity._id) {
                    return activity.name;
                }
                for (let j = 0; j < activity.activities.length; j++) {
                    let subActivity = activity.activities[j];
                    if (id == subActivity._id) {
                        return activity.name + " > " + subActivity.name;
                    }
                    for (let k = 0; k < subActivity.activities.length; k++) {
                        let childActivity = subActivity.activities[k];
                        if (id === childActivity._id) {
                            return activity.name + " > " + subActivity.name + " > " + childActivity.name;
                        }
                    }
                }

            }
    }
    deleteFromCommunityActions(propertyName, id) {
        let indexInActions = (() => {
            for (let i = 0; i < this.props.communityActions.length; i++) {
                if (this.props.communityActions[i][propertyName] && this.props.communityActions[i][propertyName] == id && !this.props.communityActions[i].deleted) {
                    return i;
                }
            }
            return -1;
        })();
        if (indexInActions != -1) {
            dispatch.createPack.removeFromCommunityAction(indexInActions);
        } else {
            let actionObject = {};
            actionObject[propertyName] = id;
            actionObject.deleted = true;
            dispatch.createPack.updateCommunityAction(actionObject);
        }
    }
    deleteR(id) {
        let index = this.props.selectedPracticeFlowCommunity.raci.r.indexOf(id);
        let message = <div className="confirmMessage">
            <h3>Delete Role</h3>
            <p>Are you sure that you wish to delete Role?</p>
            <span >This action is not reversible</span>
        </div>
        toastr.confirm(message, {
            onOk: () => {
                if (index != -1) {
                    this.deleteFromCommunityActions('r', id)
                    this.props.selectedPracticeFlowCommunity.raci.r.splice(index, 1)
                    this.props.editCommunity();

                }
            }
        });
    }
    deleteA(id) {
        let index = this.props.selectedPracticeFlowCommunity.raci.a.indexOf(id);
        let message = <div className="confirmMessage">
            <h3>Delete Role</h3>
            <p>Are you sure that you wish to delete Role?</p>
            <span >This action is not reversible</span>
        </div>
        toastr.confirm(message, {
            onOk: () => {
                if (index != -1) {
                    this.deleteFromCommunityActions('a', id)
                    this.props.selectedPracticeFlowCommunity.raci.a.splice(index, 1)
                    this.props.editCommunity();
                }
            }
        });
    }
    deleteC(id) {
        let index = this.props.selectedPracticeFlowCommunity.raci.c.indexOf(id);
        let message = <div className="confirmMessage">
            <h3>Delete Role</h3>
            <p>Are you sure that you wish to delete Role?</p>
            <span >This action is not reversible</span>
        </div>
        toastr.confirm(message, {
            onOk: () => {
                if (index != -1) {
                    this.deleteFromCommunityActions('c', id)
                    this.props.selectedPracticeFlowCommunity.raci.c.splice(index, 1)
                    this.props.editCommunity();
                }
            }
        });
    }
    deleteI(id) {
        let index = this.props.selectedPracticeFlowCommunity.raci.i.indexOf(id);
        let message = <div className="confirmMessage">
            <h3>Delete Role</h3>
            <p>Are you sure that you wish to delete Role?</p>
            <span >This action is not reversible</span>
        </div>
        toastr.confirm(message, {
            onOk: () => {
                if (index != -1) {
                    this.deleteFromCommunityActions('i', id);
                    this.props.selectedPracticeFlowCommunity.raci.i.splice(index, 1)
                    this.props.editCommunity();
                }
            }
        });
    }
    render() {
        const showForm = () => {
            if (this.props.status === 0) {
                return (
                    <Form noValidate
                        className="formcyForm"
                        name='raciForm'
                        id='raciForm'
                        ref={ref => this.form = ref}
                        onValidSubmit={(formData) => { this.addRaciToCommunity(formData) }}
                    >
                        <Grid.Row>
                            <Form.Group inline >
                                <Grid.Column width={4}>
                                    <div>
                                        <Form.Field
                                            required
                                            placeholder="RACI"
                                            name='raci'
                                            id='raci'
                                            onChange={this.createRaciObject}
                                            control='select'
                                            value={this.state.option}
                                        >
                                            <option value='raci'>RACI</option>
                                            <option value='r'>Responsible</option>
                                            <option value='a'>Accountable</option>
                                            <option value='c'>Consulted</option>
                                            <option value='i'>Informed</option>
                                        </Form.Field>
                                    </div>
                                </Grid.Column>
                                <Grid.Column width={10}>
                                    <div>
                                        <Form.Field
                                            required
                                            control='select'
                                            onChange={this.createRaciObject}
                                            name='assignment'
                                            id='assignment' >
                                            <option>Select</option>
                                            {optionsArray && optionsArray.map((activity) => {
                                                return <option value={activity.id} key={activity}>{activity.label}</option>
                                            })}
                                        </Form.Field>
                                    </div>
                                </Grid.Column>
                                <Grid.Column width={2}>
                                    <Button icon="plus" type="submit" id="submit" disabled={this.state.isDisabled}></Button>
                                </Grid.Column>
                            </Form.Group>
                        </Grid.Row>
                    </Form>
                )
            }
        }
        let deleteButton = (deleteAction, id) => {
            if (this.props.status === 0) {
                return (
                    <Grid.Column width={2}>
                        <Button icon="trash alternate" className="trash-color" style={{ 'background': 'white','padding': '5px','margin-top': '4px' }} onClick={() => deleteAction(id)}></Button>
                    </Grid.Column>
                )
            }

        }
        return (

            <Grid >
                {showForm()}
                {this.props.selectedPracticeFlowCommunity.raci && this.props.selectedPracticeFlowCommunity.raci.a && this.props.selectedPracticeFlowCommunity.raci.a.map((a) => {
                    return (
                        <Grid.Row key={a}>
                            <Grid.Column width={4}>
                                <div className="divBlock">
                                    <EllipsisTooltip name="Accountable" />
                                </div>
                            </Grid.Column>
                            <Grid.Column width={10}>
                                <div className="divBlock">
                                    <EllipsisTooltip name={this.getMapping(a)} />
                                </div>
                            </Grid.Column>
                            {deleteButton(this.deleteA, a)}
                        </Grid.Row>
                    );
                })}
                {this.props.selectedPracticeFlowCommunity.raci && this.props.selectedPracticeFlowCommunity.raci.r && this.props.selectedPracticeFlowCommunity.raci.r.map((r) => {
                    return (
                        <Grid.Row kay={r}>
                            <Grid.Column width={4}>
                                <div className="divBlock">
                                    <EllipsisTooltip name="Responsible" />
                                </div>
                            </Grid.Column>
                            <Grid.Column width={10}>
                                <div className="divBlock">
                                    {this.getMapping(r)}
                                </div>
                            </Grid.Column>
                            {deleteButton(this.deleteR, r)}
                        </Grid.Row>
                    );
                })}
                {this.props.selectedPracticeFlowCommunity.raci && this.props.selectedPracticeFlowCommunity.raci.c && this.props.selectedPracticeFlowCommunity.raci.c.map((c) => {
                    return (
                        <Grid.Row key={c}>
                            <Grid.Column width={4}>
                                <div className="divBlock">
                                    <EllipsisTooltip name="Consulted" />
                                </div>
                            </Grid.Column>
                            <Grid.Column width={10}>
                                <div className="divBlock">
                                    {this.getMapping(c)}
                                </div>
                            </Grid.Column>
                            {deleteButton(this.deleteC, c)}
                        </Grid.Row>
                    );
                })}
                {this.props.selectedPracticeFlowCommunity.raci && this.props.selectedPracticeFlowCommunity.raci.i && this.props.selectedPracticeFlowCommunity.raci.i.map((i) => {
                    return (
                        <Grid.Row key={i}>
                            <Grid.Column width={4}>
                                <div className="divBlock">
                                    <EllipsisTooltip name="Informed" />
                                </div>
                            </Grid.Column>
                            <Grid.Column width={10}>
                                <div className="divBlock">
                                    {this.getMapping(i)}
                                </div>
                            </Grid.Column>
                            {deleteButton(this.deleteI, i)}
                        </Grid.Row>
                    );
                })}



            </Grid>

        )
    }
}

export default CommunityActivityResourcePaneForm